// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3aGY8","title":"ClientReferral_title__1TC5S","itemText":"ClientReferral_itemText__PUm3s"};